import React from "react";
import {TextBalloon} from "../../common/TextBalloon";
import styles from "../../styles.module.css"
import {SelectablePlayer} from "../../common/SelectablePlayer";
import {moveToNextPhase, moveToPreviousPhase, setNightData} from "../../../features/weerwolven/slices/GameSlice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {
    selectAmountOfCardsForRole,
    selectDayNumber,
    selectNightData,
    selectPlayersWithoutAssignedRole
} from "../../../features/weerwolven/slices/GameSelectors";
import {Role} from "../../../features/weerwolven/data/Role";


export function ZusjesPhase() {
    const dispatch = useAppDispatch()
    const nightData = useAppSelector(selectNightData)
    const playersWithUnassignedRoles = useAppSelector(
        selectPlayersWithoutAssignedRole(nightData.siblings.currentZusjes))
    const currentNight = useAppSelector(selectDayNumber) + 1
    const amountOfZusjes = useAppSelector(selectAmountOfCardsForRole(Role.ZUSJE))


    return (<div>
        <div className={`${styles.Breadcrumb}`}>{currentNight}e Nacht / De Twee Zusjes</div>

        <TextBalloon text={<>De Zusjes mogen wakker worden en elkaar even aankijken.</>}/>

        <p className={`${styles.Vraag}`}>Wie zijn de Zusjes?</p>
        <div className={`${styles.NamenSelecteren}`}>
            {playersWithUnassignedRoles.map(player => {
                const isSelected = nightData.siblings.currentZusjes.includes(player.name)
                return <SelectablePlayer key={player.name} name={player.name} isSelected={isSelected} onClick={() => {
                    if (!isSelected) {
                        nightData.siblings.currentZusjes.push(player.name)
                        dispatch(setNightData(nightData))
                    } else {
                        nightData.siblings.currentZusjes = nightData.siblings.currentZusjes.filter(thisPlayer => {
                            return thisPlayer !== player.name
                        })
                        dispatch(setNightData(nightData))
                    }
                }}/>
            })}
        </div>

        <TextBalloon text={<>De Zusjes gaan weer slapen.</>}/>

        <div className={`${styles.TerugVerder}`}>
            <button className={`${styles.ButtonTerug}`} onClick={() => {
                dispatch(moveToPreviousPhase())
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}>Terug</button>
            <button className={`${styles.ButtonVerder}`}
                    disabled={nightData.siblings.currentZusjes.length !== amountOfZusjes}
                    onClick={() => {
                        dispatch(moveToNextPhase())
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}>Verder</button>
        </div>
    </div>)
}